import homeRoute from "./home";

export default [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/pc/index.vue"),
    redirect: "/home",
    children: [
      // ...homeRoute,
    ],
  },
  ...homeRoute,
];
